import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

import CreateAccountButton from '../components/CreateAccountButton';
import MarketingHero from './MarketingHero';
import { buttonStyles } from './Button';

const Button = styled(Link)`
  ${buttonStyles['secondary']};
  width: auto;
`;

const Header = ({
  title = 'Your Wedding Journey Starts Here',
  showFindACouple = true,
  subtitle = 'Plan, organise and conquer your wedding goals, with everything you need.',
  image = null,
  component = null,
  alt = '',
}) => {
  return (
    <MarketingHero
      heroImg={image}
      imgAlt={alt}
      component={component}
      subtitle={subtitle}
      title={title}
      CTA={
        <>
          <CreateAccountButton
            type="primary"
            label="Get Started For Free"
            location="hero"
          />
          {showFindACouple && <Button to={'/find'}>Find a Couple</Button>}
        </>
      }
    />
  );
};

export default Header;
